// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1967":"eeec5088","4664":"21165157","9370":"21165157","9971":"eeec5088"}[chunkId] + ".chunk.css";
};